import api from '@/api'
import getCurrentUserId from '@/utils/get-current-user-id'
import humps from 'humps'

export default {
  getAllocationRepartition (userId, portfolioId, data) {
    if (process.env.APP_ID === 'cabp') {
      return api.post(`users/${userId}/portfolios/${portfolioId}/cabp_allocation`, data)
    } else {
      return api.post(`eadvisory/portfolio_analysis/${portfolioId}/allocation`, data)
    }
  },

  getBuySellOrderList (userId, portfolioId, data) {
    return api.post(`users/${userId}/portfolios/${portfolioId}/buy_sell_order_list`, data)
  },

  getFunds(bankContractId, portfolioIds = [], userId = null, isin = []) {
    if (process.env.APP_ID === 'vieplus') {
      const params = { page: 1, limit: 10000 }

      if (portfolioIds?.length) params.portfolioIds = portfolioIds 
      if (userId) params.userId = userId
      if (isin?.length) params.isin = isin

      return api.get(`vpl/contracts/${bankContractId}/investments`, { params: humps.decamelizeKeys(params) })
    } else {
      return api.get(`contracts/${bankContractId}/investments?page=1&limit=10000`)
    }
  },

  getFees() {
    return api.post(`investments/fees`)
  },

  getFeesWithPortfolioId(data) {
    return api.post(`investments/fees`, data)
  },

  getPreviewData(userId, portfolioId, data) {
    return api.post(`users/${userId}/portfolios/${portfolioId}/arbitrations/previsualisation`, data)
  },

  createArbitration(userId, portfolioId, data) {
    return api.post(`users/${userId}/portfolios/${portfolioId}/arbitrations`, data)
  },

  getOptimizedPortfolios(userId, data) {
    return api.post(`users/${userId}/portfolios/optimize`, data)
  },

  getAllocationsMulti(userId, portfoliosIds, data) {
    // portfoliosIds is comma separated
    return api.post(`users/${userId}/portfolios/${portfoliosIds}/cabp_allocation_multi`, data)
  },

  getNormalizePortfolio(userId, portfolioId, lines) {
    return api.post(`users/${userId}/portfolios/${portfolioId}/normalize`, { lines })
  },

  // Management Acts
  getConformityCheck(userId, portfolioId, data, signal) {
    const managementAct = { portfolioId, data }
    return api.post(`users/${userId}/management_acts/simulate`, { managementAct }, { signal })
  },
  
  getIsinsPitches(isins) {
    return api.post(`/investments/pitches`, { isins })
  },

  getManagementActs(userId, managementActId) {
    return api.get(`users/${userId}/management_acts/${managementActId}`)
  },

  createManagementActs(userId, arbitrationId) {
    const managementAct = { arbitrationId }
    return api.post(`users/${userId}/management_acts`, { managementAct })
  },

  createManagementActsWealthDecision(userId, wealthDecisionId) {
    return api.post(`users/${userId}/wealth_decisions/${wealthDecisionId}/create_management_acts`)
  },

  // Update Arbitration Statuts
  setArbitrationStatus(userId, portfolioId, arbitrationId, data) {
    return api.patch(`users/${userId}/portfolios/${portfolioId}/arbitrations/${arbitrationId}`, data)
  },

  updateArbitrationStatus (arbitrationId, portfolioId, status, userId = getCurrentUserId()) {
    return api.patch(`users/${userId}/portfolios/${portfolioId}/arbitrations/${arbitrationId}`, { status })
  },

  // portfolioId not used but allows to have the same arguments as arbitration
  updateWealthDecisionStatus (wealthDecisionId, portfolioId, status, userId = getCurrentUserId()) {
    return api.put(`users/${userId}/wealth_decisions/${wealthDecisionId}`, { wealth_decision: { status } })
  },
}
